import { Checkbox, Typography } from "@fullscript/aviary-web";
import type { FormEvent } from "react";
import { Trans } from "react-i18next";

import { Link } from "@aviary";
import { sharedRoutes } from "@shared/data/sharedRoutes";
import { l } from "@shared/locales/i18n";

import * as styles from "./TermsCheckbox.styles";

interface Props {
  onChange: (event: FormEvent<HTMLInputElement>) => void;
  checked: boolean;
}
const TERMS_OF_SERVICE_URL = "https://fullscript.com/terms-of-service";

const TermsCheckbox = ({ onChange, checked }: Props) => {
  return (
    <Checkbox onChange={onChange} checked={checked}>
      <Typography variant="footnote" customCss={styles.termsCheckbox}>
        <Trans
          i18nKey={l.signin.TermsOfServiceCheckboxLabel}
          components={{
            tos: <Link isColor="success" href={TERMS_OF_SERVICE_URL} noExternalIcon />,
            privacy: (
              <Link isColor="success" href={sharedRoutes.external.privacyPolicy} noExternalIcon />
            ),
          }}
        />
        <span css={styles.asterisk}>*</span>
      </Typography>
    </Checkbox>
  );
};

export { TermsCheckbox };
